<section class="event-practical-info" [ngClass]="{ 'card p-md-4': !showOnlyImportantInfo() }">
  <h1 class="sr-only">Praktische informatie</h1>

  <div class="row gutter-y-4">
    @if (!showOnlyImportantInfo()) {
      @if (event().locations?.length || event().departments?.length) {
        <div class="col-sm-12 col-md-8">
          <h2 class="h5">{{ 'agenda-detail-info-waar' | fromDictionary }}</h2>

          <ul>
            @for (location of event().locations; track location.id) {
              <li>
                {{ location.name }}
              </li>
            }
            @if (!event().locations?.length) {
              @for (location of event().departments; track location.id) {
                <li>
                  <a class="link-reset hover--underline" [routerLink]="['/agenda']" [queryParams]="{ departments: location.id }">
                    {{ location.name }}
                  </a>
                </li>
              }
            }
          </ul>
        </div>
      }

      <div class="col-sm-12 col-md-8" [class.col-md-16]="!hasAlert()">
        <h2 class="h5">{{ 'agenda-detail-info-wanneer' | fromDictionary }}</h2>
        <ul
          class="d-flex gap-2 align-items-start flex-column"
          [class.flex-md-row]="hasRecurrencePattern()"
          [class.align-items-start]="hasRecurrencePattern()"
        >
          <li class="d-flex gap-2">
            <fstr-icon class="chip chip--secondary-subtle chip--xxs mt-1" anchor="line-icon-calendar"></fstr-icon>

            <ul>
              <li>
                <span>{{ event().startDate | eventDate: event().endDate }}</span>
              </li>
              @if (hasRecurrencePattern()) {
                @for (date of nextDates(); track $index) {
                  <li>{{ date | eventDate }}</li>
                }
              }
              @if (hasMoreDates()) {
                <li>
                  <a class="mt-2 d-inline-block" [routerLink]="'.'" [fragment]="'data'">
                    {{ 'agenda-detail-info-wanneer-meer-data' | fromDictionary }} ({{ event().eventDates?.length || 0 }})
                  </a>
                </li>
              }
            </ul>
          </li>

          <!--@if (hasRecurrencePattern()) {
            <li class="d-flex align-items-center gap-2">
              <fstr-icon class="chip chip--secondary-subtle chip--xxs" anchor="line-icon-repeat"></fstr-icon>
              <span>{{ 'event-label-is-herhalend' | fromDictionary }}</span>
            </li>
          }-->

          @if (event().displayEventStartTime || event().displayEventEndTime) {
            <li class="d-flex align-items-center gap-2">
              <fstr-icon class="chip chip--secondary-subtle chip--xxs" anchor="line-icon-clock"></fstr-icon>

              <span>
                {{ event() | eventDateTime }}
              </span>
            </li>
          }
        </ul>
      </div>
    }

    @if (hasAlert()) {
      <div class="col-sm-24 col-md-8 ms-auto">
        <!-- TODO repeating events exeption also (second) alert -->
        <app-alert [title]="event().alert?.title" [message]="event().alert?.text" [status]="'secondary'"></app-alert>
      </div>
    }
  </div>
</section>
